module.exports = __webpack_public_path__ + "static/patricia-266fc3d3718cd6ac3d7d274b890789a1.png";